/**
 * Use to early return in useEffect.
 * Usage example `return earlyInUseEffect;`
 */
export function earlyInUseEffect() {
  return {};
}
